export const GET_ADVANCED_SEARCH_REQUEST = 'GET_ADVANCED_SEARCH_REQUEST';
export const GET_ADVANCED_SEARCH_SUCCESS = 'GET_ADVANCED_SEARCH_SUCCESS';
export const GET_ADVANCED_SEARCH_ERROR   = 'GET_ADVANCED_SEARCH_ERROR';

export const GET_FILTER_DATA_REQUEST = 'GET_FILTER_DATA_REQUEST';
export const GET_FILTER_DATA_SUCCESS = 'GET_FILTER_DATA_SUCCESS';
export const GET_FILTER_DATA_ERROR   = 'GET_FILTER_DATA_ERROR';